<template>
  <div class="authentication-object-type-table-cell">
      {{$t(formattedType)}}
  </div>
</template>

<script>
import { AUTHENTICATION_OBJECT_TYPES } from '@/constants/authenticationObject';

export default {
  name: 'AuthenticationObjectTypeTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedType() {
      switch (this.item.type) {
      case AUTHENTICATION_OBJECT_TYPES.USER_PASSWORD:
        return 'auth.type.userPassword';
      case AUTHENTICATION_OBJECT_TYPES.AWS:
        return 'auth.type.awsAuth';
      case AUTHENTICATION_OBJECT_TYPES.GCP:
        return 'auth.type.gcpAuth';
      case AUTHENTICATION_OBJECT_TYPES.AZURE:
        return 'auth.type.azureAuth';
      default:
        return 'auth.type.default';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.authentication-object-type-table-cell {
  font-family: $font-family-regular;
  font-size: rem(14);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);
}

</style>
